import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from "@headlessui/react";
import { useAppSelector } from "../../app/hooks";
import { UserRole } from "../../app/userSlice";
import Avatar from "../../components/Avatar";

const basicUserNavigation = [
	{ id: "account", name: "My Account", href: "/myAccount" },
	{ id: "alerts", name: "Manage Alerts", href: "/alerts" },
	{ id: "logout", name: "Log out", href: "/logout" },
];

export default function ProfileMenu() {
	const {
		userId,
		hasImage,
		initials,
		firstName,
		lastName,
		role,
		isTeachersWriterAccount,
		requiresAccountConfirmation,
	} = useAppSelector((state) => state.user);

	const [menuItems, setMenuItems] = useState(basicUserNavigation);

	useEffect(() => {
		if (role === UserRole.Writer && !isTeachersWriterAccount) return;

		const secondToLastIndex = basicUserNavigation.length - 1;

		let name = "";
		if (role === UserRole.Proctor) {
			name = "View as Student";
		}
		if (role === UserRole.Writer && isTeachersWriterAccount) {
			name = "View as Teacher";
		}

		let newMenuItems = [
			...basicUserNavigation.slice(0, secondToLastIndex),
			{ id: "impersonate", name: name, href: "/impersonation" },
			...basicUserNavigation.slice(secondToLastIndex),
		];

		if (requiresAccountConfirmation) {
			newMenuItems = newMenuItems.map((item) =>
				item.id === "alerts" || item.id === "impersonate"
					? { ...item, href: "/myAccount" }
					: item
			);
		}
		setMenuItems(newMenuItems);
	}, [requiresAccountConfirmation, role]);

	return (
		<Menu as="div">
			<MenuButton id="profile-button" className="flex justify-center items-center">
				<div
					data-tooltip-id="avatar-icon-tooltip"
					className="h-10 w-10 flex cursor-pointer justify-center items-center rounded-full ring-2 ring-white/10 hover:ring-white/60">
					<span className="sr-only">Open user profile menu</span>

					<Avatar
						hasImage={hasImage ?? false}
						initials={initials ?? ""}
						userId={userId ?? 0}
						override={true}
						textClassName="text-white hover:opacity-85"
						borderClassName=""
						bgClassName="bg-white/10 hover:bg-white/30"
					/>
				</div>
				<Tooltip
					id="avatar-icon-tooltip"
					place="bottom-end"
					content={`${firstName} ${lastName}${isTeachersWriterAccount ? " (Student)" : ""}`}
					className="z-40"></Tooltip>
			</MenuButton>
			<Transition
				as={Fragment}
				leave="transition ease-in duration-75"
				leaveFrom="transform opacity-100 scale-100"
				leaveTo="transform opacity-0 scale-95">
				<MenuItems className="absolute -right-2 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-hidden">
					{menuItems.map((item) => {
						return (
							<MenuItem key={item.name}>
								{({ active }) => (
									<Link
										to={item.href}
										className={`${
											active ? "bg-gray-100" : ""
										} block px-4 py-2 text-sm text-gray-700`}>
										{item.name}
									</Link>
								)}
							</MenuItem>
						);
					})}
				</MenuItems>
			</Transition>
		</Menu>
	);
}
